import { render } from "./Person.vue?vue&type=template&id=6f61cb04&scoped=true"
import script from "./Person.vue?vue&type=script&lang=js"
export * from "./Person.vue?vue&type=script&lang=js"

import "./Person.vue?vue&type=style&index=0&id=6f61cb04&lang=scss&scoped=true"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mguoxueweb_online/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f61cb04"]])

export default __exports__